import React from "react";
import Layout from "../../Layout";
import HeaderReports from "../HeaderReports";
import ListMessageStatus from "./ListMessageStatus";

const MessageStatus = () => {

  return (
    <div className="MessageStatus">
      <Layout>
        <HeaderReports />
        <ListMessageStatus />
      </Layout>
    </div>
  );
};


export default MessageStatus;
